export default {
  state: {
    pageTitle: null
  },
  getters: {
    getPageTitle(state) {
      return state.pageTitle;
    }
  },
  mutations: {
    setPageTitle(state, pageTitle) {
      state.pageTitle = !pageTitle ? null : pageTitle.toString();
    }
  },
}
